import React, { useState } from "react";
import {
  Box,
  TextField,
  Switch,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  Grid,
  Typography,
  FormControlLabel,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import "./IncomeTax.css";

const IncomeTax = () => {
  const [itStatus, setItStatus] = useState(true);
  const [editable, setEditable] = useState(false);

  const [statutoryAmount, setStatutoryAmount] = useState(15000);
  const [employeeTaxContribution, setEmployeeTaxContribution] =
    useState("Basic * 12%");
  const [effectiveDate, setEffectiveDate] = useState("2020-04-01");

  const [enableCeiling, setEnableCeiling] = useState(false);
  const [lopDependant, setLopDependant] = useState(false);
  const [itIncludedInCTC, setItIncludedInCTC] = useState(false);
  const [edsliIncluded, setEdsliIncluded] = useState(false);

  const contributionOptions = [
    "Basic * 12%",
    "Basic * 10%",
    "Gross * 12%",
    "Gross * 10%",
    "Fixed Amount",
  ];

  const handleToggle = (e) => {
    setItStatus(e.target.checked);
    if (!e.target.checked) setEditable(false);
  };

  const handleSave = () => {
    setEditable(false);
    // API save logic here
  };

  return (
    <Box className="it-wrapper">
      <Box className="it-card">
        {/* Header */}
        <Box className="it-header">
          <Typography className="it-title">Income Tax Status</Typography>
          <FormControlLabel
            control={<Switch checked={itStatus} onChange={handleToggle} />}
            label={itStatus ? "Enabled" : "Disabled"}
            labelPlacement="start"
          />
        </Box>

        {itStatus && (
          <>
            {/* Form Fields */}
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Statutory Minimum Monthly Amount"
                  value={statutoryAmount}
                  onChange={(e) => setStatutoryAmount(e.target.value)}
                  disabled={!editable}
                  fullWidth
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">₹</InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <FormControl fullWidth disabled={!editable}>
                  <InputLabel>Employee Contribution</InputLabel>
                  <Select
                    value={employeeTaxContribution}
                    onChange={(e) =>
                      setEmployeeTaxContribution(e.target.value)
                    }
                    label="Employee Contribution"
                  >
                    {contributionOptions.map((opt) => (
                      <MenuItem key={opt} value={opt}>
                        {opt}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  label="Effective Date"
                  type="date"
                  value={effectiveDate}
                  onChange={(e) => setEffectiveDate(e.target.value)}
                  disabled={!editable}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>

            {/* Switches */}
            <Grid container spacing={2} className="it-switches">
              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={enableCeiling}
                      onChange={(e) => setEnableCeiling(e.target.checked)}
                      disabled={!editable}
                    />
                  }
                  label="Enable Statutory Ceiling"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={lopDependant}
                      onChange={(e) => setLopDependant(e.target.checked)}
                      disabled={!editable}
                    />
                  }
                  label="LOP Dependant"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={itIncludedInCTC}
                      onChange={(e) => setItIncludedInCTC(e.target.checked)}
                      disabled={!editable}
                    />
                  }
                  label="Income Tax Included in CTC"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={edsliIncluded}
                      onChange={(e) => setEdsliIncluded(e.target.checked)}
                      disabled={!editable}
                    />
                  }
                  label="Include EDSLI & Admin Charges"
                />
              </Grid>
            </Grid>

            {/* Action Buttons */}
            <Box className="it-actions">
              {!editable ? (
                <Button
                  variant="contained"
                  startIcon={<EditIcon />}
                  onClick={() => setEditable(true)}
                >
                  Edit
                </Button>
              ) : (
                <>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={handleSave}
                  >
                    Save
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => setEditable(false)}
                  >
                    Cancel
                  </Button>
                </>
              )}
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default IncomeTax;
